var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreast = function SvgBreast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 3.233v13.542a.63.63 0 0 1-.625.625H8.433a.63.63 0 0 1-.625-.625v-2.45h-.116c-.117 0-.234 0-.35-.017-2.175-.166-3.6-1.4-3.959-3.383-.35-.25-.575-.65-.575-1.108 0-.792.717-1.425 1.492-1.35 1.742-1.742 4.808-5.592 4.842-5.634a.623.623 0 0 1 .975.775c-.142.175-3.467 4.35-5.209 6a.622.622 0 0 1-.708.109c-.1-.017-.15.033-.15.091 0 .05.033.084.075.1a.616.616 0 0 1 .442.525c.183 1.609 1.15 2.492 2.866 2.625.992.075 1.817-.275 2.525-1.083a.63.63 0 0 1 .884-.058.63.63 0 0 1 .058.883c-.533.608-1.158 1.042-1.842 1.283v2.059h4.792V3.233a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625Z",
    fill: "current"
  })));
};
export default SvgBreast;